import React from 'react';
import { Box, Button, Divider, Grid, Paper, Tooltip, Typography, makeStyles } from '@material-ui/core/';
import ProductSearchWrapper from '../Product/ProductSearchWrapper';
import { productJsonProps, productPanelFields } from '../../Constants/Products';
import { get, isNil } from 'lodash';
import { formatIVM, getProductImgUrl, getProductPdpUrl, getProductUpdatedTime } from '../../Utils/ProductUtils';
import { Avatar } from '@material-ui/core';
import CachedIcon from '@material-ui/icons/Cached';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import ProductBuyable from '../Product/ProductBuyable';
import CopyClipboardField from '../common/CopyClipboardField';
import { ManageProducts_NavLink_To } from '../../Constants/AppBar';
import { Link } from 'react-router-dom';
import classeNames from 'classnames';
import { useDispatch } from 'react-redux';
import { refreshProductFromBifrost } from '../../redux/actions/manageAssetActions';

const useStyles = makeStyles((theme) => ({
	subtitle: {
		fontWeight: '525',
	},
	paper: {
		padding: theme.spacing(2),
		maxWidth: 600,
		minWidth: 400,
	},
	productImg: {
		width: theme.spacing(15),
		height: theme.spacing(15),
		backgroundColor: 'orange',
		textAlign: 'center',
		color: 'black',
		'& img': {
			objectFit: 'fill',
		},
	},
	productDesc: {
		display: 'block',
	},
	link: {
		textDecoration: 'none',
		textTransform: 'uppercase',
	},
}));

const ProductDataRefresh = ({ productId, assetId }) => {
	const dispatch = useDispatch();
	// Refresh product data in `Product` ES index from Bifrost.
	const handleRefreshBtnClick = () => {
		dispatch(refreshProductFromBifrost({ productId, assetId }));
	};
	const titleMsg = isNil(productId) ? 'Product Not Selected' : 'Refresh PRODUCT DATA';
	return (
		<Tooltip title={titleMsg} arrow={true} placement="top">
			<span>
				<Button
					color="primary"
					startIcon={<CachedIcon color="primary" />}
					onClick={handleRefreshBtnClick}
					disabled={isNil(productId)}
				>
					Refresh
				</Button>
			</span>
		</Tooltip>
	);
};
const LowesProductPageBtn = ({ url }) => {
	// disable lowes product page Btn when no product is selected.
	const isUrlEmpty = url === '';
	const titleMsg = isUrlEmpty ? 'Product not selected' : 'View on Lowes.com';
	return (
		<Tooltip title={titleMsg} arrow={true} placement="top">
			<span>
				<Button
					startIcon={<OpenInNewIcon color="primary" />}
					color="primary"
					onClick={() => window.open(url)}
					disabled={isUrlEmpty}
				>
					Lowes.com
				</Button>
			</span>
		</Tooltip>
	);
};
// view product on CORGIS product details page.
const ProductDetailsBtn = ({ productUUID }) => {
	const classes = useStyles();
	const productDetailsCls = classeNames({
		disabled: isNil(productUUID),
		[classes.link]: true,
	});
	// disable product details Btn when no product is selected.
	const titleMsg = isNil(productUUID) ? 'Product Not Selected' : 'view this product on Corgis product details page.';
	return (
		<Tooltip title={titleMsg} arrow={true} placement="top">
			<span>
				<Link to={ManageProducts_NavLink_To + '/' + productUUID} target="_blank" className={productDetailsCls}>
					<Button startIcon={<OpenInNewIcon color="primary" />} color="primary" disabled={isNil(productUUID)}>
						Product Details
					</Button>
				</Link>
			</span>
		</Tooltip>
	);
};

const ProductInfoPanel = (props) => {
	const classes = useStyles();
	const { product, asset } = props;
	const productUUID = product?.id;
	const productId = get(product, productJsonProps.productId);
	const barcode = get(product, productJsonProps.barcode);
	const ivm = formatIVM(product);
	const productImgUrl = getProductImgUrl(product);
	const isBuyable = get(product, productJsonProps.buyable);
	const ProductTypographyFields = ({ label }) => {
		return (
			<Typography className={classes.subtitle} display="inline">
				{label}:
			</Typography>
		);
	};
	return (
		<Paper className={classes.paper}>
			<Grid container spacing={1}>
				<ProductSearchWrapper {...props} />
				<Grid item xs={4}>
					<Avatar className={classes.productImg} alt="" variant="square" src={productImgUrl}>
						<Box p={0.3}> {isNil(productUUID) ? 'Product Needed' : 'Image Missing'}</Box>
					</Avatar>
				</Grid>
				<Grid item xs={8}>
					<Grid container alignItems="baseline">
						<ProductTypographyFields label={productPanelFields.productId} />
						<CopyClipboardField fieldName="Product ID" val={productId} />
					</Grid>
					<Grid container alignItems="baseline">
						<ProductTypographyFields label={productPanelFields.barcode} />
						<CopyClipboardField fieldName="Barcode" val={barcode} />
					</Grid>
					<Grid container alignItems="baseline">
						<ProductTypographyFields label={productPanelFields.ivm} />
						<CopyClipboardField fieldName={productPanelFields.ivm} val={ivm} />
					</Grid>
					<Grid container alignItems="baseline">
						<ProductTypographyFields label={productPanelFields.lastUpdatedAt} />
						<Typography variant="body2" display="inline">
							{getProductUpdatedTime(product)}
						</Typography>
					</Grid>
					<Grid container alignItems="baseline">
						<ProductTypographyFields label={productPanelFields.isBuyable} />
						<ProductBuyable isBuyable={isBuyable} />
					</Grid>
				</Grid>
			</Grid>
			<Box m={1} />
			<Divider variant="fullWidth" />
			<Grid container>
				<Grid item xs={4}>
					<ProductDataRefresh productId={productId} assetId={asset.id} />
				</Grid>
				<Grid item xs={4}>
					<LowesProductPageBtn url={getProductPdpUrl(product)} />
				</Grid>
				<Grid item xs={4}>
					<ProductDetailsBtn productUUID={productUUID} />
				</Grid>
			</Grid>
		</Paper>
	);
};

export default ProductInfoPanel;
